export const smoothReorder = <T>(items: T[], getOrder: (item: T) => number): T[] => {
  return [...items].sort((a, b) => getOrder(b) - getOrder(a));
};
